import React from 'react';
import { Row, Col, Card, Container } from 'react-bootstrap';
import { Droppable } from 'react-beautiful-dnd';
import Info from '../info/info';
import PropTypes from 'prop-types';


function Column(props) {
    return (
        <Col xs={6}>
            <Card>
                <Card.Header style={{ backgroundColor: '#753DFF', color: '#FFFFFF' }}>
                    <h3 style={{ color: '#FFFFFF' }}>{props.column.title}</h3>
                </Card.Header>
                <Card.Body style={{ height: '400px', overflowY: 'scroll' }}>
                    <Row>
                        <Col xs={12} className='text-center'>
                            <Container
                                fluid='xs'
                                style={{
                                    display: 'flex',
                                    flexDirection: 'column'
                                }}
                            >
                                <Droppable droppableId={props.column.id}>
                                    {(provided, snapshot) => (
                                        <Card
                                            style={{
                                                backgroundColor: snapshot.isDraggingOver ? '#ACB0FF' : '#FFFFFF',
                                                flexGrow: 1,
                                                padding: '8px',
                                                minHeight: '100px'
                                            }}
                                            ref={provided.innerRef}
                                            {...provided.droppableProps}
                                            isDraggingOver={snapshot.isDraggingOver}
                                        >
                                            {props.tasks.map((task, index) => (
                                                <Info key={task.id} task={task} index={index} />
                                            ))}
                                            {provided.placeholder}
                                        </Card>
                                    )}
                                </Droppable>
                            </Container>
                      </Col>
                  </Row>
              </Card.Body>
          </Card>
      </Col>
    )
}

Column.propTypes={
    column:PropTypes.object,
    tasks:PropTypes.array
}

export default Column;